import OAuth from '../../services/oauth';
import { doesBodyHaveUserId, doesWindowLocationHaveParam } from '../../services/window';

export default function clearApiTokensIfUserSignedOut() {
  if (!doesBodyHaveUserId() && doesWindowLocationHaveParam('logged_out')) {
    OAuth.clearApiTokens();
  }
}
